export { default } from './SectionAbout';